'use client';

import { useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';
import { GenericErrorPage } from '@app-test2/shared-components';
import { useLocale } from 'next-intl';

export default function Error({
  error,
}: {
  error: Error & { digest?: string };
}) {
  const locale = useLocale();

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return <GenericErrorPage locale={locale as 'fr' | 'en'} />;
}
